import React from "react";
import _ from "lodash";
import AppConstants from "../../constants/AppConstants";
import DesignContextUtils from "../../utils/DesignContextUtils";
import { DESIGN_CONTEXT } from "../../constants/DesignContextConstants";
import PlaceholderBackground from "../utils/PlaceholderBackground";
import ImgIcon from "@/app2components/panel/element/image/ImgIcon";
import { CROP_MODE } from "@/constants/UIConstants";

const {
  GRAPHIC_SCALE_CONTAIN,
  GRAPHIC_SCALE_FILL,
  GRAPHIC_SCALE_STRETCH,
  GRAPHIC_SCALE_ZOOM,
  RESOURCE_ASSET,
} = AppConstants;

const Graphic = ({ elemProps, content, id, inheritShadow = false, layout, mode }) => {
  if(mode?.type === CROP_MODE && mode?.crop?.selectedImageId === id) return null;

  const style = {
    width: "100%",
    height: "100%",
    boxShadow: inheritShadow ? "inherit" : "unset",
    borderRadius: inheritShadow ? "inherit" : "unset",
  };

  //TODO remove once old images are cleared out of content
  if (!_.isObject(content)) {
    return (
      <div style={{ backgroundColor: "#884444", height: "100%", width: "100%" }}>
        Remove From Model
      </div>
    );
  }

  if (content.get("key") === undefined) {
    const placeholderInstrux = <span>Double click to add an image</span>;

    return (
      <div>
        <PlaceholderBackground
          layout={layout}
          icon={<ImgIcon style={{ width: "100%", height: "100%" }} />}
          instrux={placeholderInstrux}
        />
      </div>
    );
  }

  const contentType = content.get("type", "unknown");
  if (contentType === RESOURCE_ASSET) {
    const designContext = elemProps.get(DESIGN_CONTEXT);
    const { generateDesignAssetUrl } = DesignContextUtils.fromContext(designContext);

    const url = generateDesignAssetUrl({ content, elemProps });
    style.backgroundImage = `url(${url})`;
    style.backgroundRepeat = "no-repeat";
    const scale = elemProps.getIn(["gs", "t"], GRAPHIC_SCALE_FILL);

    switch (scale) {
      case GRAPHIC_SCALE_FILL:
        style["backgroundSize"] = "cover";
        style["backgroundPosition"] =
          elemProps.getIn(["gs", "s"], "50") + "% " + elemProps.getIn(["gs", "s"], "50") + "%";
        break;
      case GRAPHIC_SCALE_CONTAIN:
        style["backgroundSize"] = "contain";
        style["backgroundPosition"] = "50%";
        break;
      case GRAPHIC_SCALE_STRETCH:
        style["backgroundSize"] = "100% 100%";
        style["backgroundPosition"] = "50%";
        break;
      case GRAPHIC_SCALE_ZOOM:
        style["backgroundSize"] = elemProps.getIn(["gs", "p"], "100") + "%";
        style["backgroundPosition"] =
          elemProps.getIn(["gs", "x"], "50") + "% " + elemProps.getIn(["gs", "y"], "50") + "%";
        break;
    }
  }

  return <div style={style}></div>;
};

export default Graphic;
